<template>
  <div class="school-finder">
    <form id="search-form" method="get" :action="schoolSearchUrl" novalidate="novalidate">
      <div class="form-group">
        <div class="autocomplete">
          <div class="input">
            <input v-model="search" v-click-outside="clearResults"  @input="doSearch()" type="search" id="search-input" name="q" class="form-control" placeholder="Enter school name or location" autocomplete="off">
          </div>
        </div>
      </div>
    </form>

    <ul v-if="schools && showResults" class="bg-white school-finder-results list-unstyled p-0">
      <li v-for="school in schools" :key="school.id">
        <a :href="school.url" class="d-block">
          <div class="d-flex align-items-center">
            <img :src="school.logo_url" :alt="school.name" width="28" height="auto" class="mr-4">
            {{ school.name }}
          </div>
        </a>
      </li>
      <li class="no-image">
        <a href="/school-finder" class="d-block text-center">View All Schools</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: null,
      schools: null,
      showResults: false
    };
  },

  props: {
    schoolSearchUrl: {
      type: String,
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    doSearch: _.debounce(function () {
      if (this.search !== null && this.search.length > 1) {
        axios.post('/api/v1/schools/autocomplete', {
            'search': this.search,
          })
          .then(res => {
            if (res.data && res.data.success) {
              this.schools = res.data.schools;
              this.showResults = true;
            } else {
              this.clearResults();
            }
          })
          .catch(err => {
            //
          })
          .finally(() => {

          });
      } else {
        this.clearResults();
      }

    }, 300),
    clearResults() {
      this.schools = null;
      this.showResults = false;
    }
  },
};
</script>
